function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useTranslation } from 'react-i18next';
import ReportNotesForm from '@rd-web-markets/market/dist/technicalProof/summarySection/ProjectNotesForm';
import ReportNotesTable from '@rd-web-markets/market/dist/technicalProof/summarySection/ProjectNotesTable';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
const ClaimProjectNotes = _ref => {
  var _report$report_notes;
  let {
    isImmutableUnderReview,
    report,
    setReport,
    pageAccess,
    reportNotesHandlers
  } = _ref;
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const currentUser = useSelector(state => state.auth.user);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const {
    notes,
    setNotes,
    createNote,
    updateNote,
    deleteNote,
    loading
  } = reportNotesHandlers;
  useEffect(() => {
    if (report.report_notes) {
      setNotes(report.report_notes);
    }
  }, [report.id, (_report$report_notes = report.report_notes) === null || _report$report_notes === void 0 ? void 0 : _report$report_notes.length]);
  const handleCreateNote = async formData => {
    try {
      const response = await createNote(formData);
      const updatedNotes = [response, ...notes];
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport(_objectSpread({}, report));
      setHasUnsavedChanges(false);
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const handleUpdateNote = async _ref2 => {
    let {
      id,
      data
    } = _ref2;
    try {
      const response = await updateNote({
        id,
        data
      });
      const updatedNotes = notes.map(n => n.id === id ? response : n);
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport(_objectSpread({}, report));
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const handleDeleteNote = async noteId => {
    try {
      await deleteNote(noteId);
      const updatedNotes = notes.filter(n => n.id !== noteId);
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport(_objectSpread({}, report));
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(ReportNotesForm, {
    loading: loading,
    onSubmit: handleCreateNote,
    noteType: "comments",
    isImmutableUnderReview: isImmutableUnderReview,
    setHasUnsavedChanges: setHasUnsavedChanges
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(ReportNotesTable, {
    notes: notes,
    onUpdate: handleUpdateNote,
    onDelete: handleDeleteNote,
    userCanEdit: true,
    loading: loading,
    filterByType: null,
    showTypeColumn: true,
    currentUserId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
    setHasUnsavedChanges: setHasUnsavedChanges
  }))))))));
};
export default ClaimProjectNotes;